// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"_1851g","text":"+KK54","wrapper":"t-7zC","label":"ESh8d","field":"SGfj+"};